window.ttx = window.ttx || {};
ttx.console = {
    /**
     * data 用来暂存console的内容，调用上报的策略时会存储在本地
     */
    data: {
        trace: [],
        debug: [],
        info: [],
        warn: [],
        error: []
    },
    /**
     * topLimit data中每一项存储条数的上限
     * trace 调用信息，因内容较大，占用内存较多
     * debug 调试信息，数量较多
     * info 日志信息，数量极多，但作用较大
     * warn 警告信息，数量不多
     * error 错误信息，数量不多且一般error为阻塞问题，大部分已经上报ymc
     */
    topLimit: {
        trace: 300,
        debug: 5000,
        info: 10000,
        warn: 1000,
        error: 800
    },
    /**
     *  日志等级:
     * 0: 关闭状态，不打印任何日志
     * 1: 开启状态，仅打印error信息
     * 2: 开启状态，仅打印error信息与warn信息
     * 3: 开启状态，打印error信息、warn信息与info、log日志
     * 4: 开启状态，打印error信息、warn信息、(info + log)日志以及debug调试日志
     * 5: 开启状态，打印error信息、warn信息、(info + log)日志、debug调试日志以及trace调用信息
     * > 5 目前仅有五级，大于5的即为all
     */
    keyMap: {
        1: 'error',
        2: 'warn',
        3: 'info',
        4: 'debug',
        5: 'trace',
    },
    /**
     * 反向映射，与keymap相反,用于初始化过程时同步consul配置使用
     */
    levelMap: {
        ERROR: 1,
        WARN: 2,
        INFO: 3,
        DEBUG: 4,
        TRACE: 5,
    },
    warningUrls: [
        // 资源相关
        'mdf/resource/loadExtend',
        // 模板相关
        'billmeta/getTplId',
        'billmeta/tpllist',
        'billmeta/getfebill',
        'client/getInitFilterInfo',
        // 主要业务接口
        'bill/detail',
        'bill/list',
        'bill/add',
        'bill/save',
        'report/list',
        'user/getLoginUser',
        'makeBill/pullVoucher',
    ],
    /**
     *
     * @returns
     * 初始化主动上报和巡查上报
     */
    init: function () {
        return null;
    },
    /**
     *
     * @returns
     * 获取日志等级
     */
    getLogLevel: function () {
        // 默认等级 3：正常输出 error/warn/info/log，debug/trace 需 debug 模式或不显式开启
        let level = this.levelMap[window.__LOG_LEVEL__] || 3;
        if (ttx.debug === true && level < 4) {
            level = 4
        }
        if (ttx.debugRule === true && level < 4) {
            level = 4
        }
        return level;
    },
    /**
     *
     * @returns
     * 获取当前工作台tabs页签的名称
     */
    getTabName: function () {
        const tabName = ttx.rest?._activeTabName;
        return tabName ? '[' + tabName + ']' : ''
    },
    /**
     *
     * @param {*} msg
     * @param  {...any} args
     * 此处只封装 trace、debug、info、log、warn、error
     * 其中tarce的使用频率最低，只有最高级别的时候才开启trace的日志
     * debug其次，只有调试的场景才启用
     * log与info暂时不区分，均作为日志记录使用
     * warn为警告类型
     * error为错误类型，正常情况下错误类型需要走ymc的上报机制
     *
     *
     * 上报 indexDB只上报msg args不上报 避免e、error、 HTMLDOM等非规范结构注入导致上报失败
     */
    trace: function (msg, ...args) {
        if (this.getLogLevel() > 4) {
            const tabName = this.getTabName()
            const content = `【MDF】【trace】${tabName}[diworkCode:${ttx.rest?._activeTabCode}]${msg}` // @notranslate
            // eslint-disable-next-line
            console.trace(content, ...args)
            if (this.data.trace?.length == this.topLimit.trace) {
                this.data.trace = [];
            }
            this.data.trace.push({
                msg: content,
                // args: { ...args }
            })
        }
    },
    debug: function (msg, ...args) {
        if (this.getLogLevel() > 3) {
            const tabName = this.getTabName()
            const content = `%c【MDF】【debug】${tabName}[diworkCode:${ttx.rest?._activeTabCode}]${msg}` // @notranslate
            // eslint-disable-next-line
            console.debug(content, 'color: blue', ...args)
            if (this.data.debug?.length == this.topLimit.debug) {
                this.data.debug = [];
            }
            this.data.debug.push({
                msg: content,
                // args: { ...args }
            })
        }
    },
    log: function (msg, ...args) {
        if (this.getLogLevel() > 2) {
            const tabName = this.getTabName()
            const content = `%c【MDF】【log】${tabName}[diworkCode:${ttx.rest?._activeTabCode}]${msg}` // @notranslate
            // eslint-disable-next-line
            console.log(content, 'color: #ccc', ...args)
            if (msg && !msg.includes?.('mdf_reporting_log')) {
                if (this.data.info?.length == this.topLimit.info) {
                    this.data.info = [];
                }
                this.data.info.push({
                    msg: content,
                    // args: { ...args }
                })
            }
        }
    },
    info: function (msg, ...args) {
        if (this.getLogLevel() > 2) {
            const tabName = this.getTabName()
            const content = `%c【MDF】【info】${tabName}[diworkCode:${ttx.rest?._activeTabCode}]${msg}` // @notranslate
            // eslint-disable-next-line
            console.info(content, 'color: #ccc', ...args)
            if (this.data.info?.length == this.topLimit.info) {
                this.data.info = [];
            }
            this.data.info.push({
                msg: content,
                // args: { ...args }
            })
        }
    },
    warn: function (msg, ...args) {
        if (this.getLogLevel() > 1) {
            const tabName = this.getTabName()
            const content = `【MDF】【warn】${tabName}[diworkCode:${ttx.rest?._activeTabCode}]${msg}` // @notranslate
            // eslint-disable-next-line
            console.warn(content, ...args)
            if (this.data.warn?.length == this.topLimit.warn) {
                this.data.warn = [];
            }
            this.data.warn.push({
                msg: content,
                // args: { ...args }
            })
        }
    },
    error: function (errorObj, msg, ...args) {
        if (this.getLogLevel() > 0) {
            const tabName = this.getTabName()
            if (errorObj && !msg) {
                msg = errorObj
                errorObj = { code: 'E00000', text: '通用类错误' } // @notranslate
            }
            if (!errorObj) {
                errorObj = { code: 'E00000', text: '通用类错误' } // @notranslate
            }
            const errText = errorObj.text ? `[${errorObj.text}]` : ''
            const diworkCode = ttx.rest?._activeTabCode ? `[diworkCode:${ttx.rest._activeTabCode}]` : ''
            const content = `【MDF】【error】${tabName}${errText}${diworkCode}${msg || ''}` // @notranslate
            // eslint-disable-next-line
            console.error(errorObj.code ?? errorObj, content, ...args)
            if (this.data.error?.length == this.topLimit.error) {
                this.data.error = [];
            }
            this.data.error.push({
                errorObj,
                msg: content,
                // args: { ...args }
            })
        }
    },
    detailLog: function (...args) {
        if (window.__DETAIL_LOG__) {
            ttx.console.error(...args)
        }
    },
    checkError: function (options = {}, errorMessage) {
        const url = options.url
        const checkUrl = this.warningUrls.find(function (item) {
            return url?.split('?')?.[0]?.replace(/^\//, '') === item;
        });
        if (checkUrl) {
            // 自定义错误码，预警错误码
            ttx.console.error(Error.E01999 || 'E01999', errorMessage)
        } else {
            ttx.console.error(Error.E01000 || 'E01000', errorMessage)
        }
    },
    clear: function () {
        // eslint-disable-next-line
        console.clear();
    }
}
